import React, { useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Pagination from '../Pagination'
import { updateStateSiswaAttendance } from '../../features/siswaAttendanceHistorySlice'
import orangImage from '../../assets/images/user-foto.png'
import imgErrorValidation from '../../utils/imgErrorValidation'

let PageSize = 10;

function IzinTable() {
    const { izinList, isLoading, currentPage } = useSelector(state => state.siswaAttendanceHistory)
    const dispatch = useDispatch()

    const currentTableData = useMemo(() => {
        const firstPageIndex = (currentPage - 1) * PageSize
        const lastPageIndex = firstPageIndex + PageSize
        return izinList?.slice(firstPageIndex, lastPageIndex)
    }, [izinList, currentPage])

    return (
        <>
            <table className='table'>
                <thead>
                    <tr>
                        <th className='th-niy'>NIY</th>
                        <th className='th-name'>Nama Siswa</th>
                        <th className='th-jabatan'>Kelas</th>
                        <th className='th-jabatan'>Jenis Izin</th>
                        <th className='th-jabatan'>Mulai Izin</th>
                        <th className='th-jabatan'>Selesai Izin</th>
                        <th className='th-jabatan'>Deskripsi</th>
                        <th className='th-jabatan'>File</th>
                    </tr>
                </thead>
                <tbody>
                    {isLoading
                        ? <tr className='loading loading-table'><td>loading...</td></tr>
                        : currentTableData?.length === 0
                            ? <tr className='loading-table'><td>Data tidak ditemukan</td></tr>
                            : currentTableData?.map((item, key) => (
                                <tr key={key}>
                                    <td className='niy-col'>{item?.student?.niy}</td>
                                    <td className='row-img'>
                                        <img src={orangImage} onError={imgErrorValidation} alt="" />
                                        {item?.student?.nama}
                                    </td>
                                    <td>{item?.student?.classes?.category}</td>
                                    <td style={{ textTransform: 'capitalize' }}>{item?.jenis_izin}</td>
                                    <td>{item?.mulai_izin}</td>
                                    <td>{item?.selesai_izin}</td>
                                    <td>{item?.deskripsi || '-'}</td>
                                    <td>
                                        {item?.link_file
                                            ? <a href={item.link_file} target="_blank" rel="noreferrer" style={{ color: '#3661EB' }}>Lihat File</a>
                                            : '-'
                                        }
                                    </td>
                                </tr>
                            ))
                    }
                </tbody>
            </table>

            {!isLoading && (
                <Pagination
                    className="pagination-bar"
                    currentPage={currentPage}
                    totalCount={izinList?.length}
                    pageSize={PageSize}
                    onPageChange={page => dispatch(updateStateSiswaAttendance({ name: 'currentPage', value: page }))}
                />
            )}
        </>
    )
}

export default IzinTable
